<template>
  <section class="cash-payment-view">
    <cash-calculator v-model="clientMoneyAmount" :disabled="isLoading" />
    <div class="amounts-wrapper mb-5">
      <v-row dense>
        <v-col sm="4">
          <div class="amount">
            <div class="amount-label mb-2">
              Получено:
            </div>
            <div class="amount-value client-money">
              {{ clientMoney | amountWithCurrency }}
            </div>
          </div>
        </v-col>
        <v-col sm="4">
          <div class="amount">
            <div class="amount-label mb-1">
              К оплате:
            </div>
            <div class="amount-value total">
              {{ total | amountWithCurrency }}
            </div>
          </div>
        </v-col>
        <v-col sm="4">
          <div class="amount">
            <div class="amount-label mb-1">
              Сдача:
            </div>
            <div class="amount-value change">
              {{ change | amountWithCurrency }}
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
    <large-btn
      class="primary-confirm-dialog_btn primary-confirm-dialog_btn__confirm"
      color="primary"
      height="64px"
      :uppercase="false"
      block
      :loading="isLoading"
      @click="pay"
    >
      <font-awesome-icon icon="check" class="mr-2" />
      Оплата произведена
    </large-btn>
  </section>
</template>

<script>
  import PaymentType from '@/models/enums/PaymentType'
  import CashCalculator from '../CashCalculator.vue'
  import paymentApi from '@/api/order/payment'
  import LargeBtn from '@/components/ui/buttons/LargeBtn.vue'

  export default {
    name: 'CashPaymentView',
    components: { CashCalculator, LargeBtn },
    props: {
      orderId: {
        type: [String, Number],
        default: null,
      },
      clientMoney: Number,
      total: Number,
      loading: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        change: 0,
      }
    },
    computed: {
      clientMoneyAmount: {
        get () { return this.clientMoney },
        set (newValue) { this.$emit('update:client-money', newValue) },
      },
      isLoading: {
        get () { return this.loading },
        set (newValue) { this.$emit('update:loading', newValue) },
      },
    },
    watch: {
      clientMoney () {
        this.calcChange()
      },
    },
    created () {
      this.calcChange()
    },
    methods: {
      calcChange () {
        this.change = this.clientMoney > this.total ? this.clientMoney - this.total : 0
      },
      async pay () {
        if (!this.orderId) {
          return
        }

        this.isLoading = true
        try {
          await paymentApi.complete(this.orderId, { type: PaymentType.Cash, clientMoney: this.clientMoney })
          this.$emit('paid')
        } catch (e) {
          this.showErrorFromResponse(e)
        } finally {
          this.isLoading = false
        }
      },
    },
  }
</script>

<style lang="less" scoped>
.cash-payment-view {
  padding: 17px 27px;
}
.amounts-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
}
.amount {
  width: 100%;
  text-align: center;

  &-label {
    font-size: 20px;
    color: #DDD;
    line-height: 1;
  }

  &-value {
    line-height: 1;
  }
}
.client-money {
    color: #DB9415;
    font-size: 22px;
  }

  .total {
    color: #161616;
    font-size: 32px;
    margin-left: 8px;
  }

  .change {
    display: inline-block;
    color: #090909;
    font-size: 22px;
    background-color: #FFF3D6;
    border-radius: 7px;
    padding: 4px 20px;
  }
</style>
